<script>
 	import Format from '../layouts/partials/Format.svelte';
	import { Tabs, TabList, TabPanel, Tab } from '../components/tabs/tabs.js';
	import Video from '../components/Video.svelte';
</script>
<div class="format-page">
	<div class="top-section">
		<h1 class="title">Format</h1>
		<Video url="https://www.youtube.com/watch?v=frGAezPhY8M" thumb="/images/frGAezPhY8M-HD.jpg"/>
		<div class="format-details">
			<Format />
		</div>
	</div>
</div>
<Tabs>
	<TabList>
		<Tab active={true}>Open Qualifiers </Tab>
		<Tab>Challenger Round</Tab>
		<Tab>Contender Round</Tab>
		<Tab >League Stage</Tab>
		<Tab>Quarter Finals</Tab>
		<Tab>Semi Finals</Tab>
		<Tab>Grand Finals</Tab>
	</TabList>
	<TabPanel active={true}>
		<div class="container">
			<section class="process-content">
				<div class="container">
					<div class="row mt-40 pb-4">
						<div class="col-md-12">
							<p class="col-paragraph">
								Teams who have registered for Snapdragon Conquest Mobile Open will have to play a series of two matches for multiple rounds. The total scores of the squad in 2 matches will be considered. In event of tie, other parameters including finishes, position points etc. will be considered and the top 112 Teams will qualify for the next round. If a Team fails to compete 2 matches, their scores would be calculated based on the match played. 
							</p>
						</div>
					</div>
				</div>
			</section>
		</div>
	</TabPanel>
	<TabPanel>
		<div class="container">
			<section class="process-content">
				<div class="container">
					<div class="row mt-40 pb-4">
						<div class="col-md-12">
							<p class="col-paragraph">
								The top 112 squads qualifying from Open Qualifiers and 16 Invited Teams will be seeded into 8 groups. Each group will have to play 6 matches each on the specified dates. The top 7 teams from each group will further qualify for the Contender Round. 
							</p>
						</div>
					</div>
				</div>
			</section>
		</div>
	</TabPanel>
	<TabPanel >
		<div class="container">
			<section class="process-content">
				<div class="container">
					<div class="row mt-40 pb-4">
						<div class="col-md-12">
							<p class="col-paragraph">
								The Top 56 teams and additional 8 Invited teams will be seeded into 4 groups. Each group will have to play 9 matches on the specified dates. Top 6 teams will from each group will further qualify for League Stage.  
							</p>
						</div>
					</div>
				</div>
			</section>
		</div>
	</TabPanel>
	<TabPanel>
		<div class="container">
			<section class="process-content">
				<div class="container">
					<div class="row mt-40 pb-4">
						<div class="col-md-12">
							<p class="col-paragraph">
								Total of 32 Teams – qualified 24 teams from Contender Round and 8 Invited Teams. The Teams will be divided into 4 groups of 8 Teams. The Top 24 Teams will be qualifying to the finals of each week based on their cumulative point standings of the first two days of the week. The Top 24 teams based on the cumulative point standings of the finals of each week will qualify for Quarter Finals. 
							</p>
						</div>
					</div>
				</div>
			</section>
		</div>
	</TabPanel>
	<TabPanel>
		<div class="container">
			<section class="process-content">
				<div class="container">
					<div class="row mt-40 pb-4">
						<div class="col-md-12">
							<p class="col-paragraph">
								24 Teams from previous round will be divided into 3 groups of 8 teams each. Teams will play matches in a round robin over 3 days in a week. Bottom 4 teams will be eliminated, and the remaining 20 teams will be move onto Semi Finals. 
							</p>
						</div>
					</div>
				</div>
			</section>
		</div>
	</TabPanel>
	<TabPanel>
		<div class="container">
			<section class="process-content">
				<div class="container">
					<div class="row mt-40 pb-4">
						<div class="col-md-12">
							<p class="col-paragraph">
								20 Teams from Quarter Finals will be divided into 5 groups of 4 teams each. Teams will play matches in a round robin over 4 days in two weeks. Bottom 4 teams will be eliminated, and the remaining 16 teams will be move onto the Grand Finals. 
							</p>
						</div>
					</div>
				</div>
			</section>
		</div>
	</TabPanel>
	<TabPanel>
		<div class="container">
			<section class="process-content">
				<div class="container">
					<div class="row mt-40 pb-4">
						<div class="col-md-12">
							<p class="col-paragraph">
								16 Teams from the Semi Finals will play the Grand Finals. The Grand Finals will include 36 matches which will be played across 5 days. The Team with the highest cumulative score in the leader board at the end of the 5 days will be crowned as the champions of the Tournament. 
							</p>
						</div>
					</div>
				</div>
			</section>
		</div>
	</TabPanel>
</Tabs>
<style>
	.title {
		font-size: 42px;
		font-family: 'Qualcomm Next Medium';
		margin-bottom: 0;
		text-align: center;
		letter-spacing: 0;
		color: #ffffff;
		padding: 80px 0 40px 0;
	}

	.btn-section {
		padding-top: 50px;
	}

	.col-heading {
		font-size: 16px;
		font-family: "Qualcomm Next Medium";
		font-stretch: normal;
		font-style: normal;
		line-height: 1.5;
		letter-spacing: normal;
		letter-spacing: 0;
		color: #0b2742;
	}

	.col-paragraph {
		font-size: 16px;
		line-height: 24px;
		font-weight: normal;
		font-stretch: normal;
		font-style: normal;
		letter-spacing: normal;
		letter-spacing: 0;
		color: #0b2742;
		margin-bottom: 2rem;
	}

	.register-btn {
		width: 300px;
		text-decoration: none;
		margin-bottom: 20px;
		border-radius: 25px;
		font-size: 16px;
		font-family: "Qualcomm Next Medium";
		font-stretch: normal;
		font-style: normal;
		letter-spacing: normal;
		text-align: center;
		display: inline-block;
		background-color: #ffffff;
		color: #3253dc;
		border: none;
	}

	.register-text {
		font-size: 16px;
		color: #ffffff;
		font-weight: normal;
		font-stretch: normal;
		font-style: normal;
		line-height: normal;
		letter-spacing: normal;
		text-align: center;
	}

	.register-text a {
		font-family: "Qualcomm Next Medium";
		color: #ffffff;
		text-decoration: none;
	}
</style>